export default "__VITE_ASSET__C2lfuLo2__"